module.exports = __webpack_public_path__ + "c3d7c9e05efd145d457ae5a7b6c0bfc2.png";